import { Redirect } from "react-router-dom";
import Loader from "components/ui/Loader/Loader";
import { useEffect, useState } from "react";
import { useAccount } from "context/AccountContext";
import useData from "hooks/useData";

const Logout = () => {
  const { setUser, setProfile } = useAccount();
  const { getData } = useData();
  const [ loading, setLoading ] = useState();

  const handleLogout = async () => {
    setLoading(true);
    try {
      await getData(`rest/user/logout`);
      setLoading(false);
    } catch (exception) {
      console.log(exception);
    }
  }

  useEffect(
    () => {
      handleLogout();

      setUser(null);
      setProfile(null);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);

  if (loading) {
    return <Loader containerVariant={ 'fixed' }/>;
  }

  return <Redirect to={ `/` }/>;
}

export default Logout;
